import axios from 'axios'
import type {pincode} from '../types/types'

const baseurl = `${import.meta.env.VITE_APP_PROTOCOL}://${import.meta.env.VITE_API_HOST}:${import.meta.env.VITE_API_PORT}/${import.meta.env.VITE_API_SUBPATH}`
const url = 'pincode'

export const readPincodeListAPI = async (): Promise<pincode[]> => {
  const response = await axios.get(`${baseurl}${url}`, { 
    params: {
      cmd: 'list'
    }
  })
  console.log("readPincodeListAPI 응답:", response.data)
  return response.data.data
}

export const updatePincodeAPI = async (id: number) => {
  const response = await axios.get(`${baseurl}${url}`, {
    params: {
      cmd: 'new',
      id: id
    }
  })
  console.log("updatePincodeAPI 응답:", response.data)
  return response.data.data
}
export const newPincodeAPI = async () => {
  const response = await axios.get(`${baseurl}${url}`, {
    params: {
      cmd: 'new',
    }
  })
  console.log("newPincodeAPI 응답:", response.data)
  return response.data.data
}

export const removePincodeAPI = async (id: number) => {
  const response = await axios.get(`${baseurl}${url}`, {
    params: {
      cmd: 'remove',
      id: id
    }
  })
  console.log("removePincodeAPI 응답:", response.data)
  return response.data
}
